import * as React from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';

import placeholder from 'assets/images/table/placeholderBig.webp';

const NoOptOutLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 450px;
  background-image: url(${placeholder});
  background-repeat: no-repeat;
  background-size: cover;
`;

const Text = styled.p`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black[100]};
  text-align: center;
  margin-bottom: 32px;
`;

export const NoOptOuts = () => {
  const { t } = useTranslation();
  return (
    <NoOptOutLayout>
      <Text>{t('You currently have no Opt-Outs')}</Text>
    </NoOptOutLayout>
  );
};
